import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-arai-auction',
  templateUrl: './arai-auction.component.html',
  styleUrls: ['./arai-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AraiAuctionComponent {
  @Input() lang = 'ru';
}
